var JsonViewItemFieldSerializeKind = {
	JSON_VIEW: 'JSON_VIEW',
	STRING_VIEW: 'STRING_VIEW',
	PRIMITIVE_FIELD: 'PRIMITIVE_FIELD',
	REFERENCE: 'REFERENCE'
};

export default JsonViewItemFieldSerializeKind;
